import { useMutation } from '@tanstack/react-query';
import { UpdateUserDataRequestTypes } from '../_types/updateUserDataRequest.types';
import { apiUserAccount } from '../../../utils/ApiService';
import { ApiEndpoints } from '../constantes/ApiEndpoints';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';

interface RegisterUserResponse {
  participantId: string;
}

export const useRegisterUser = () => {
  const schemaId = getSchemaIdFromStorage();
  
  const {
    mutate: registerUser,
    isLoading,
    error,
    isError
  } = useMutation({
    mutationFn: async (data: UpdateUserDataRequestTypes): Promise<RegisterUserResponse> => {
      try {
        return await apiUserAccount.post<RegisterUserResponse>(
          `${ApiEndpoints.account.register}?schemaId=${schemaId}`,
          data
        );
      } catch (error) {
        throw error;
      }
    }
  });
  
  return {
    registerUser,
    isRegistering: isLoading,
    registerError: error,
    hasRegisterError: isError
  };
};
